import _ from 'lodash'
import axios from 'axios'
import { db } from '@/store/firebase'
import formJSON from '@/../functions/shared/forms.json'
import apiFormulas from '@/api/formulas'
import apiGestations from '@/api/gestation'
import StudyUtils from '@/utils/studyUtils'
import firestoreUtil from '@/utils/firestore'

const gestation = { patientData: {} }
const gestationInteraction = { patientData: {} }

const state = {
  gestation,
  gestationInteraction,
  gestationInteractions: [],
  formKeysWithFormulas: apiFormulas.getKeysWithFormulas(formJSON),
  formConfig: apiFormulas.getConfig(formJSON),
  formJSON: formJSON,
  dicomParams: [],
  dicomDeviceParams: {},
  dicomForms: {},
  patient: {},
  company: {},
  studies: [],
  studiesHistory: [],
  initTemplates: false,
  templates: [],
  unsubscribes: {}
}

const getters = {
  study (state) {
    return state.studies.length > 0 ? state.studies[0] : {}
  },
  gestationInteractionPenultimate (state) {
    if (!state.gestationInteraction ||
      (!state.gestationInteractions || state.gestationInteractions.length < 2)) return null
  },
  gestationWithInteractions (state) {
    let gestation = _.cloneDeep(state.gestation)
    gestation.interactions = [
      ..._.cloneDeep(state.gestationInteractions.filter(item => item.iuid !== state.gestationInteraction.iuid))
    ]

    delete gestation.company
    delete gestation.patient

    gestation.interactions.map(item => {
      delete item.gestation
      delete item.patient
      delete item.doctor
      return item
    })

    return gestation
  },
  params (state) {
    // if (state.dicomParams) {
    //   return state.dicomParams.reduce((acc, item) => {
    //     if (item.params) {
    //       if (!acc[item.ManufacturerModelName]) acc[item.ManufacturerModelName] = []
    //       acc[item.ManufacturerModelName] = acc[item.ManufacturerModelName].concat(item.params)
    //     }
    //     return acc
    //   }, {})
    // }
    // return {}
    return state.dicomDeviceParams
  }
}

const actions = {
  getGestationAndInterations ({ dispatch, commit, state }, payload) {
    let promisses = []

    promisses.push(dispatch('getGestation', payload))
    promisses.push(dispatch('getGestationInteractions', payload))

    return Promise.all(promisses)
  },
  getGestation ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      if (state.unsubscribes.Gestation) state.unsubscribes.Gestation()
      state.unsubscribes.Gestation = db.doc('gestations/' + payload).onSnapshot(async data => {
        if (!data.exists) {
          commit('setGestation', null)
          resolve(null)
        }
        const gestation = firestoreUtil.docToObject(data)
        commit('setGestation', gestation)
        resolve(gestation)
      })
    })
  },
  getGestationInteraction ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      if (state.unsubscribes.GestationInteraction) state.unsubscribes.GestationInteraction()
      state.unsubscribes.GestationInteraction = db.doc('gestationInteraction/' + payload).onSnapshot(async data => {
        if (!data.exists) {
          commit('setGestationInteraction', null)
          return
        }
        let gestation = firestoreUtil.docToObject(data)
        if (gestation.forms) {
          gestation.forms = firestoreUtil.parseTimestampToDateInObj(gestation.forms)
        }
        commit('setGestationInteraction', gestation)
        resolve(gestation)
      })
    })
  },
  getGestationInteractions ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      if (state.unsubscribes.GestationInteractions) state.unsubscribes.GestationInteractions()
      state.unsubscribes.GestationInteractions = db.collection('gestationInteraction')
        .where('gestation', '==', db.doc('gestations/' + payload))
        .orderBy('date', 'asc')
        .onSnapshot(async data => {
          if (data.empty) {
            commit('setGestationInteractions', [])
            return
          }

          let gestations = data.docs.map(item => {
            let gi = firestoreUtil.docToObject(item)
            if (gi.forms) {
              gi.forms = firestoreUtil.parseTimestampToDateInObj(gi.forms)
            }
            return gi
          })

          commit('setGestationInteractions', gestations)
          resolve(gestations)
        })
    })
  },
  async setGestationInteractionPrint ({ commit, state }, payload) {
    let gi = _.cloneDeep(state.gestationInteraction)
    gi.print = payload
    await apiGestations.update(gi)
    // commit('setGestationInteraction', gi)
  },
  getPatient ({ commit, dispatch, state }, payload) {
    return db.doc('patients/' + payload).get().then(async data => {
      const patient = firestoreUtil.docToObject(data)
      dispatch('getCompany', patient.company.identity)
      commit('setPatient', patient)
    })
  },
  getCompany ({ commit, state }, payload) {
    return db.collection('companies').where('identity', '==', payload).get().then(async query => {
      if (!query.empty) {
        const data = query.docs[0]
        commit('setCompany', firestoreUtil.docToObject(data))
      }
    })
  },
  getDicomParams ({ commit, state }, payload) {
    // verifica se tem a empresa selecionada
    if (payload.identity === undefined) return commit('setDicomParams', [])
    let date = null
    if (payload.studyDate) {
      date = payload.studyDate.replace(/-/g, '')
    } else {
      date = payload.date.toISOString().substring(0, 10).replace(/-/g, '')
    }
    // BS BUCKET PROECHO
    const identity = payload.identity === '40179459000542' ? 'PROECHO' : payload.identity
    return db.collection('dicomParams')
      .where('patId', '==', payload.patId)
      .where('StudyDate', '==', date)
      .where('info.dicomStoreId', '==', identity)
        .get()
        .then(query => {
          let result = []
          // Se não tiver imagens, grava um array vazio
          if (!query.empty) {
            // Converte snapshot para array
            const docs = query.docs.map(doc => firestoreUtil.docToObject(doc))
            // Ordena os documentos
            result = _.orderBy(docs, ['StudyID', 'SeriesNumber', 'InstanceNumber'], ['asc', 'asc', 'asc'])
            // Grava no state
          }
          commit('setDicomParams', result)
        })
  },
  getDicomDeviceParams ({ commit, state }, payload) {
    const date = payload.date.toISOString().substring(0, 10).replace(/-/g, '')
    const url = `https://app.ultrahealth.care/functions/healthcareParams?patId=${payload.patId}&date=${date}`
    commit('setDicomDeviceParams', {})
    return axios
      .get(url)
      .then(res => {
        commit('setDicomDeviceParams', res.data)
      })
      .catch(err => {
        commit('setDicomDeviceParams', {})
        console.error(err)
      })
  },
  getDicomForms ({ commit, state }) {
    // if (state.dicomForms === {}) return
    return db.doc(`dicomForms/${state.company.iuid}`)
      .get()
      .then(query => {
        if (query.exists) {
          commit('setDicomForms', firestoreUtil.docToObject(query))
        }
      })
  },
  find ({ commit, state, rootState }, payload) {
    return axios
      .get(
        `https://www.ultravideo.com.br/companies/${
          rootState.company
        }/studies/${payload}`
      )
      .then(res => {
        commit('setStudies', [res.data])
      })
      .catch(err => {
        commit('setStudies', null)
        console.error(err)
      })
  },
  findByPatId ({ commit, state, rootState }, payload) {
    return axios
      .get(
        `https://www.ultravideo.com.br/companies/${
          rootState.company
        }/studies?patId=${payload}`
      )
      .then(res => {
        commit('setStudiesHistory', StudyUtils.groupByDate(res.data.list))
      })
      .catch(err => {
        commit('setStudiesHistory', null)
        console.log(err)
      })
  },
  findByPatIdAndServiceDate ({ commit, state, rootState }, payload) {
    return db.collection('studies')
      .where('patId', '==', payload.patId)
      .where('serviceDate', '==', payload.serviceDate)
      .get()
      .then(query => {
        let studies = []
        query.forEach(item => {
          studies.push(item.data())
        })
        studies = studies.sort((a, b) => {
          return (a.pathVideo + a.accessionNo).localeCompare(
            b.pathVideo + b.accessionNo
          )
        })
        commit('setStudies', studies)
      })
      .catch(err => {
        commit('setStudies', null)
        console.log(err)
      })
  },
  initListTemplates ({ commit, state, rootState }) {
    const loadTemplates = function () {
      // Consulta para templates da empresa
      const companyTemplatesQuery = db.collection('templates')
        .where('company.identity', '==', rootState.company)
        .orderBy('name', 'asc')

      // Consulta para templates do sistema
      const systemTemplatesQuery = db.collection('templates')
        .where('isSystem', '==', true)

      // Listener para templates da empresa
      const unsubscribeCompany = companyTemplatesQuery.onSnapshot(async companyData => {
        // Busca templates do sistema
        const systemData = await systemTemplatesQuery.get()

        let templates = []

        // Adiciona templates da empresa
        if (!companyData.empty) {
          templates = companyData.docs.map(item => firestoreUtil.docToObject(item))
        }

        // Adiciona templates do sistema
        if (!systemData.empty) {
          const systemTemplates = systemData.docs.map(item => firestoreUtil.docToObject(item))
          templates = [...templates, ...systemTemplates]
        }

        // Ordena todos os templates por nome
        templates = _.orderBy(templates, ['name'], ['asc'])

        commit('setTemplates', templates)
      })

      // Armazena o unsubscribe para limpeza posterior
      if (state.unsubscribes.templates) {
        state.unsubscribes.templates()
      }
      state.unsubscribes.templates = unsubscribeCompany
    }

    if (state.initTemplates) {
      loadTemplates()
    } else {
      commit('setInitTemplates', true)
      _.delay(loadTemplates, 5000)
    }
  },
  setPatient ({ commit, state }, payload) {
    commit('setPatient', payload)
  },
  unsubscribe ({ commit, state }, payload) {
    commit('unsubscribe', payload)
  }
}

const mutations = {
  setGestation (state, payload) {
    state.gestation = payload || gestation
  },
  setGestationInteraction (state, payload) {
    state.gestationInteraction = payload || gestation
  },
  setGestationInteractions (state, payload) {
    state.gestationInteractions = payload || []
  },
  setPatient (state, payload) {
    state.patient = payload || {}
  },
  setCompany (state, payload) {
    state.company = payload || {}
  },
  setDicomDeviceParams (state, payload) {
    state.dicomDeviceParams = payload || {}
  },
  setDicomParams (state, payload) {
    state.dicomParams = payload || []
  },
  setDicomForms (state, payload) {
    state.dicomForms = payload || {}
  },
  setStudies (state, payload) {
    state.studies = payload || []
  },
  setStudiesHistory (state, payload) {
    state.studiesHistory = payload || []
  },
  setInitTemplates (state, payload) {
    state.initTemplates = payload || false
  },
  setTemplates (state, payload) {
    state.templates = payload || []
  },
  unsubscribe (state, payload) {
    if (state.unsubscribes && state.unsubscribes[payload]) {
      state.unsubscribes[payload]()
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/ultra-fetal/index.js